/**
 * The list of countries where marketing SMS are allowed.
 */
export const MARKETING_SMS_ELIGIBLE_COUNTRIES = 'MARKETING_SMS_ELIGIBLE_COUNTRIES';
